export const UNAUTHENTICATED = "UNAUTHENTICATED";
